import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mall-help" }
const _hoisted_2 = { class: "mall-help__shell" }
const _hoisted_3 = { class: "mall-help__head" }
const _hoisted_4 = { class: "mall-help__eyebrow" }
const _hoisted_5 = { class: "mall-help__layout" }
const _hoisted_6 = {
  class: "mall-help__nav",
  "aria-label": "고객센터 정책"
}
const _hoisted_7 = { class: "mall-help__doc" }
const _hoisted_8 = { class: "mall-help__summary" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { MALL_NAME } from '@/constants/mall'
import { MALL_HELP_TOPICS, findMallHelpTopic, mallHelpPath } from '@/constants/mallHelp'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallHelpPage',
  setup(__props) {

const route = useRoute()
const current = computed(() => findMallHelpTopic(String(route.params.topic || 'guide')))

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(MALL_NAME)), 1),
        _cache[0] || (_cache[0] = _createElementVNode("h1", null, "고객센터", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "주문, 결제, 배송, 환불 기준을 한곳에서 확인합니다.", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("nav", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MALL_HELP_TOPICS), (topic) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: topic.id,
              to: _unref(mallHelpPath)(topic.id),
              class: _normalizeClass(["mall-help__nav-item", { 'is-active': topic.id === current.value.id }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(topic.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128)),
          _createVNode(_component_router_link, {
            to: "/mall/mypage/consults",
            class: "mall-help__nav-item"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" 문의 내역 ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("article", _hoisted_7, [
          _createElementVNode("h2", null, _toDisplayString(current.value.label), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(current.value.summary), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current.value.sections, (section) => {
            return (_openBlock(), _createElementBlock("section", {
              key: section.title,
              class: "mall-help__section"
            }, [
              _createElementVNode("h3", null, _toDisplayString(section.title), 1),
              _createElementVNode("p", null, _toDisplayString(section.body), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})